import dsBridge from 'dsbridge';

/**
 * 检测是否存在方法名
 *
 */
export function kkBridgeHasMethod(handlerName: string, type?: 'all' | 'asyn' | 'syn') {
  return dsBridge.hasNativeMethod(handlerName, type);
}

// 豆豆判断app某个js交互是否存在
export function ddcheckNativeMethod(handlerName: string) {
  if (window.Android) {
    return !!window.Android[handlerName];
  }
  return dsBridge.call('checkNativeMethod', JSON.stringify({ handlerName })) === 'true';
}
// 同步获取
export function kkBridgeCallAsync(handlerName: string) {
  return dsBridge.call(handlerName);
}
/**
 * js->app
 * @param handlerName 方法名称
 * @param args 传递参数
 * @param responseCallback  异步调用，处理回调结果
 */

export function kkBridgeCall(
  handlerName: string,
  args: Record<string, unknown>,
  responseCallback?: (retValue: any) => void
) {
  if (kkBridgeHasMethod(handlerName)) {
    dsBridge.call(handlerName, JSON.stringify(args), responseCallback);
  } else {
    throw Error(`没有提供${handlerName}`);
  }
}

export const kkSdk = (handlerName: string, obj?: Record<string, unknown>) =>
  new Promise((resolve) => {
    if (kkBridgeHasMethod(handlerName)) {
      dsBridge.call(handlerName, JSON.stringify(obj ?? {}), (data) => {
        resolve(data);
      });
    } else {
      console.error(`没有提供${handlerName}`);
      resolve('');
    }
  });

/**
 * app->js 注册方法供app调用
 * @param handlerName 方法名称
 * @param handler 接收方法
 * @param async 同步 false 异步 true
 */
export function kkBridgeReg(
  handlerName: string,
  handler: Record<string, unknown> | (() => any),
  async?: boolean
) {
  if (async) {
    dsBridge.registerAsyn(handlerName, handler);
  } else {
    dsBridge.register(handlerName, handler);
  }
}

/**
 * app->js 注册方法供app调用
 * @param handlerName 方法名称
 * @param handler 接收 app返回的参数和h5端的方法
 * @param async 同步 false 异步 true
 */
export function kkBridgeRegwithdata(
  handlerName: string,
  responseCallback?: (retValue: any, two: any, three: any) => void,
  // responseCallback?: (retValue: any) => void,
  async?: boolean
) {
  if (async) {
    dsBridge.registerAsyn(handlerName, responseCallback);
  } else {
    dsBridge.register(handlerName, responseCallback);
  }
}

/**
 *
 * @param handlerName 注册名
 * @param async 同步 false 异步 true
 */
export function kkBridgeUnRegwithdata(handlerName: string, async?: boolean) {
  if (!handlerName) return;
  if (async) {
    delete window._dsaf[handlerName];
  } else {
    delete window._dsf[handlerName];
  }
}

export function registerFunction(
  handlerName: string,
  handler: Record<string, unknown> | (() => any),
  async?: boolean
) {
  if (handlerName) {
    // 卡卡
    if (import.meta.env.VITE_APP_NAME === 'kaka') {
      if (async) {
        dsBridge.registerAsyn(handlerName, handler);
      } else {
        dsBridge.register(handlerName, handler);
      }
    } else if (import.meta.env.VITE_APP_NAME === 'doudou') {
      console.log('豆豆注册方法');
    }
  }
}

/**
 * 向app请求
 * @param { String } handlerName 方法名称
 * @param { Object } params 传递参数
 * @param { Boolean } async 是否是异步 默认同步
 * @return { * } promise 返回值
 */

export async function getMessage<T>(
  handlerName: string,
  params: any, // Record<string, unknown>,
  async: boolean
  // successCallback?: any // (retValue: any) => void,
  // failCallBack?: any // (retValue: any) => void,
) {
  return new Promise<T>((resolve, reject) => {
    if (!handlerName) {
      reject(new Error('方法名必传'));
    }
    // 是否有回调 必须为布尔值
    if (typeof async !== 'boolean') {
      async = false;
    }
    // 卡卡
    // if (import.meta.env.VITE_APP_NAME === 'kaka') {
    if (!dsBridge.hasNativeMethod(handlerName)) {
      reject(new Error(`没有提供${handlerName}`));
    }
    // params 必须为对象类型
    if (
      typeof params !== 'object' ||
      Object.prototype.toString.call(params).slice(8, -1).toLowerCase() !== 'object'
    ) {
      params = {};
    }
    if (async) {
      kkBridgeCall(handlerName, params, (data) => {
        resolve(data);
      });
    } else {
      resolve(dsBridge.call(handlerName, JSON.stringify(params)));
    }
  });
}
